import { Box, Progress, type ProgressTrackProps } from '@chakra-ui/react';
import type React from 'react';
import type { FC } from 'react';

export interface FaceliftProgressProps {
	value: number | null;
	size?: 'sm' | 'md' | 'lg';
}

export interface ProgressTrackProps2 extends ProgressTrackProps {
	children?: React.ReactNode;
}

const CustomProgress = {
	Root: (props: React.ComponentProps<typeof Progress.Root>) => (
		<Progress.Root {...props} />
	),
	Track: (props: ProgressTrackProps2) => <Progress.Track {...props} />,
	Range: (props: React.ComponentProps<typeof Progress.Range>) => (
		<Box as={Progress.Range} bg="brand.solidGradient" {...props} />
	),
};

const FaceliftProgress: FC<FaceliftProgressProps> = ({
	value,
	size = 'sm',
	...rest
}) => {
	return (
		<CustomProgress.Root
			width="100%"
			value={value}
			size={size}
			colorPalette="brand"
			{...rest}
		>
			<CustomProgress.Track>
				<CustomProgress.Range />
			</CustomProgress.Track>
		</CustomProgress.Root>
	);
};

export default FaceliftProgress;
